import { useMemo } from 'react';
import { useUnit } from 'effector-react';
import dayjs from 'dayjs';
import { $initialAccountsStore } from '@lib/store';
import { AccountType } from '@shared/api';
import { AccountsSummary } from './accountsSummary';
import { MonthlyTransaction } from './monthlyTransaction';
import { YearlyTransaction } from './yearlyTransaction';

export const PaymentTab = () => {
  const accountStore = useUnit($initialAccountsStore.store);

  const paymentAccounts = useMemo(() => accountStore.data.filter((account) => account?.type === AccountType.Payment), [accountStore.data]);
  const minimalDate = useMemo(() => dayjs.min(paymentAccounts.map((acc) => dayjs(acc.dateCreated)))?.format(), [paymentAccounts]);
  return (
    <>
      <AccountsSummary />
      <MonthlyTransaction minimalYear={dayjs(minimalDate).year()} minimalMonth={dayjs(minimalDate).month() + 1} />
      <YearlyTransaction minimalYear={dayjs(minimalDate).year()} />
    </>
  );
};
